(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.zhHansCn = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    domain: '',
    menuToggle: {
      label: 'MENU'
    },
    logo: {
      href: '/'
    },
    mainBtn: [{
      text: '获取报价',
      link: '/get-quote'
    }, {
      text: '用户登录',
      link: ''
    }],
    loginLink: {
      text: '用户登录',
      src: ''
    },
    siteLinks: [{
      title: {
        text: '产品'
      },
      list: [{
        text: 'Concur 费用管理',
        src: '/expense-management'
      }, {
        text: 'Concur 差旅申请',
        src: '/travel-request'
      }, {
        text: 'Concur 对公支付',
        src: '/invoice-management'
      }, {
        text: 'Concur 商业智能分析',
        src: '/business-intelligence'
      }, {
        text: 'Concur 预算管控',
        src: '/budget-management'
      }, {
        text: 'Concur 移动应用',
        src: '/expense-mobile'
      }, {
        text: 'Concur与SAP 系统集成',
        src: '/sap-integration'
      }, {
        text: '获取报价',
        src: '/get-quote',
        classes: 'call-out'
      }]
    }, {
      title: {
        text: '解决方案'
      },
      list: [{
        text: '企业出海',
        src: '/global-travel-expense-management'
      }, {
        text: '费用合规',
        src: '/compliance-fraud'
      }, {
        text: '高科技行业',
        src: '/hi-tech'
      }, {
        text: '生命科学与医药行业',
        src: '/life-sciences'
      }, {
        text: '能源行业',
        src: '/oil-mine-gas'
      }, {
        text: '滴滴企业出行解决方案',
        src: '/didi'
      }, {
        text: '微信发票方案',
        src: '/wechat-e-fapiao'
      }, {
        text: '携程商旅平台整合',
        src: '/ctrip-integration'
      }]
    }, {
      title: {
        text: '关于 Concur'
      },
      list: [{
        text: '关于SAP Concur',
        src: '/about-concur'
      }, {
        text: '差旅及费用管理平台',
        src: '/concur-integrated-ecosystem'
      }, {
        text: '全球分布',
        src: '/contact/offices'
      }, {
        text: '就业机会',
        src: ''
      }, {
        text: '联系我们',
        src: '/contact',
        classes: 'call-out'
      }]
    }, {
      title: {
        text: '资源'
      },
      list: [{
        text: '成功案例',
        src: '/casestudy'
      }, {
        text: '资源中心',
        src: '/resource-centre'
      }, {
        text: '新闻发布',
        src: '/media-resources/press-releases'
      }, {
        text: '费用管理动态演示',
        src: '/self-guided-demo-expense-zh-cn#/',
        classes: 'call-out'
      }, {
        text: '对公支付动态演示',
        src: '/self-guided-demo-invoice-zh-cn#/',
        classes: 'call-out'
      }]
    }],
    supportLinks: [{
      text: '加入我们',
      href: '/careers'
    }, {
      text: '联系我们',
      href: '/contact'
    }, {
      text: '销售热线：400-675-6753'
    }],
    mobileAppText: {
      text: 'GET CONCUR MOBILE APP'
    }
  };
});